// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buttons-group[data-v-27816e88] {\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.buttons-group > .button[data-v-27816e88]:not(:last-child) {\n  margin-right: 0.5em;\n}", ""]);
// Exports
module.exports = exports;
